import * as z from 'zod';
import { currencySchema } from '../../../utils.mjs';
import { LineItemGroup } from './line-item-group.mjs';

var IncomeStatementData;
(function (IncomeStatementData) {
    IncomeStatementData.schema = z.object({
        revenue: LineItemGroup.schema,
        cogs: currencySchema.nullable(),
        grossProfit: currencySchema.nullish(),
        operatingExpenses: currencySchema.nullable(),
        operatingProfit: currencySchema.nullish(),
        otherIncome: currencySchema.nullable(),
        otherExpenses: currencySchema.nullable(),
        taxes: currencySchema.nullable(),
        netProfit: currencySchema.nullish(),
        profitable: z.boolean().nullish(),
        depreciation: currencySchema.nullable(),
        amortization: currencySchema.nullable(),
        depreciationAndAmortization: currencySchema.nullable(),
        interestExpense: currencySchema.nullable(),
        incomeTaxes: currencySchema.nullable(),
        irregularGainLossFromAssetSale: currencySchema.nullable(),
        distributions: currencySchema.nullable(),
    });
})(IncomeStatementData || (IncomeStatementData = {}));

export { IncomeStatementData };
